'use client';
import { Button, Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
	button,
	icon,
	tableTd,
	tableTdAction,
} from '@mage-ui/styled-system/recipes';

//TableCell
export const TableTdAction = ({ data, ...props }) => {
	const tdProps = {};
	if (data?.colspan) {
		tdProps.colSpan = data.colspan;
	}
	if (data?.rowspan) {
		tdProps.rowSpan = data.rowspan;
	}

	return (
		<td className={cx(tableTd(), tableTdAction())} {...props} {...tdProps}>
			<Button
				onClick={data?.action}
				classNames={{ root: button({ size: 's', variant: 'ghost' }) }}
				leftSection={
					data?.iconName && (
						<Icon name={data?.iconName} classNames={icon({ size: 's' })} />
					)
				}
			>
				{data?.title}
			</Button>
		</td>
	);
};
